import Logo from "../../../../assets/icons/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { INavigation } from "../../utils/interfaces";
import { ItemTypes } from "../../utils/enums";
import iSamWatch from "../../../../assets/icons/watch_icon_1.png";
import iSamTheme from "../../../../assets/icons/theme_icon_1.png";
import iSamStudio from "../../../../assets/icons/studio_icon_1.png";
import iSamAbout from "../../../../assets/icons/samabout_icon_1.png";
import iYamWatch from "../../../../assets/icons/yam_icon.png"
import SamWatch from "../../../../assets/icons/watch_1.png";
import SamTheme from "../../../../assets/icons/theme_1.png";
import SamStudio from "../../../../assets/icons/studio_1.png";
import SamAbout from "../../../../assets/icons/samabout_1.png";
import YamWatch from "../../../../assets/icons/yam_watch.png"

export const Navigation = (props: INavigation) => {
  const [ItemType, setItemType] = useState(""),
    navigate = useNavigate(),
    { name } = props,
    setGradient = () => {
      switch (name) {
        case ItemTypes.SAM_WATCH:
          return "from-blue-800 to-[#002b71]";
        case ItemTypes.YAM_WATCH:
          return "from-[#fcc92c] to-[#e5006e]";
        case ItemTypes.SAM_THEME:
          return "from-teal-400 to-sky-600";
        case ItemTypes.SAM_STUDIO:
          return "from-orange-500 to-rose-600";
        default:
          return "from-sky-600 to-[#006cbb]";
      }
    };

  const [isDarkMode, setIsDarkMode] = useState(true);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    let prefersDark = true;

    if (savedTheme) {
      prefersDark = savedTheme === "dark";
    } else {
      prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    }

    setIsDarkMode(prefersDark);
    if (prefersDark) {
      document.documentElement.classList.add("dark");
      document.documentElement.classList.remove("light");
    } else {
      document.documentElement.classList.remove("dark");
      document.documentElement.classList.add("light");
    }
  }, []);

  const toggleTheme = () => {
    if (isDarkMode) {
      document.documentElement.classList.remove("dark");
      document.documentElement.classList.add("light");
      localStorage.setItem("theme", "light");
      setIsDarkMode(false);
    } else {
      document.documentElement.classList.add("dark");
      document.documentElement.classList.remove("light");
      localStorage.setItem("theme", "dark");
      setIsDarkMode(true);
    }
  };

  useEffect(() => { setItemType(name); }, [name]);

  return (
    <nav
      className={`relative flex w-screen p-4 items-center justify-center [&>*]:hover:cursor-pointer max-w-screen bg-gradient-to-r ${setGradient()}`}
    >
      <div className="w-fit mx-2" onClick={() => navigate("/samwatch")}>
        <img
          className={`h-7 md:h-7 object-contain max-w-fit ${ItemType === ItemTypes.SAM_WATCH && "hidden"
            }`}
          src={iSamWatch}
          alt=""
        />
        <img
          className={`h-[30px] md:h-[34px] object-contain max-w-fit ${ItemType !== ItemTypes.SAM_WATCH && "hidden"
            }`}
          src={SamWatch}
          alt=""
        />
      </div>
      <div className="w-fit mx-2" onClick={() => navigate("/yamwatch")}>
        <img
          // style={{ height: "2.5rem"}}
          className={`h-7 md:h-8 object-contain max-w-fit ${ItemType === ItemTypes.YAM_WATCH && "hidden"
            }`}
          src={iYamWatch}
          alt=""
        />
        <img
          className={`h-[30px] md:h-[34px] object-contain max-w-fit ${ItemType !== ItemTypes.YAM_WATCH && "hidden"
            }`}
          src={YamWatch}
          alt=""
        />
      </div>
      <div className="w-fit mx-2" onClick={() => navigate("/samtheme")}>
        <img
          className={`h-7 md:h-7 object-contain max-w-fit ${ItemType === ItemTypes.SAM_THEME && "hidden"
            }`}
          src={iSamTheme}
          alt=""
        />
        <img
          className={`h-[30px] md:h-[34px] object-contain max-w-fit ${ItemType !== ItemTypes.SAM_THEME && "hidden"
            }`}
          src={SamTheme}
          alt=""
        />
      </div>
      <div className="w-fit mx-2" onClick={() => navigate("/samstudio")}>
        <img
          className={`h-7 md:h-7 object-contain max-w-fit ${ItemType === ItemTypes.SAM_STUDIO && "hidden"
            }`}
          src={iSamStudio}
          alt=""
        />
        <img
          className={`h-[30px] md:h-[34px] object-contain max-w-fit ${ItemType !== ItemTypes.SAM_STUDIO && "hidden"
            }`}
          src={SamStudio}
          alt=""
        />
      </div>
      <div className="w-fit mx-2" onClick={() => navigate("/samabout")}>
        <img
          className={`h-7 md:h-8 object-contain max-w-fit ${ItemType === ItemTypes.SAM_ABOUT && "hidden"
            }`}
          src={iSamAbout}
          alt=""
        />
        <img
          className={`h-[30px] md:h-[34px] object-contain max-w-fit ${ItemType !== ItemTypes.SAM_ABOUT && "hidden"
            }`}
          src={SamAbout}
          alt=""
        />
      </div>
    </nav>
  );
};
